export default "/images/a722560db24f6ff2878c66fad9fd2d0d.avif";